import { render, staticRenderFns } from "./ProviderApprovalResultRow.vue?vue&type=template&id=675a59c7&scoped=true"
import script from "./ProviderApprovalResultRow.vue?vue&type=script&lang=js"
export * from "./ProviderApprovalResultRow.vue?vue&type=script&lang=js"
import style0 from "./ProviderApprovalResultRow.vue?vue&type=style&index=0&id=675a59c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a59c7",
  null
  
)

export default component.exports